module.exports = __webpack_public_path__ + "static/img/89062E_2_3_R_20200102_fit.4cdf9cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/89062E_2_3_R_20200102_fit.png
// module id = X5KW
// module chunks = 0